import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Spremiste2DComponent } from '@app/components/spremiste2D/spremiste2d.component';
import { AppLayoutComponent } from '@app/layout/app.layout.component';
import { MAIN_VIEW_COMPONENT } from '@environments/environment';
import { HierarhijaComponent, KlasaListComponent } from './components';
import { AgentPrikazComponent } from './components/agent-prikaz/agent-prikaz.component';
import { DokumentacijaHierarhijaComponent } from './components/dokumentacija/dokumentacija-hierarhija.component';
import { HierarhijaKlasifikacijaComponent } from './components/hierarhija-klasifikacija/hierarhija-klasifikacija.component';
import { HierarhijaPosebniPopisComponent } from './components/hierarhija-posebni-popis/hierarhija-posebni-popis.component';
import { HierarhijaPozicijaComponent } from './components/hierarhija-pozicija/hierarhija-pozicija.component';
import { AuthGuard } from './components/login.component/service/auth-guard.service';
import { MainHierarchylistviewComponent } from './components/main-hierarchylistview/main-hierarchylistview.component';
import { MojaInstitucijaComponent } from './components/moja-institucija/moja-institucija.component';
import { MojeGradivoComponent } from './components/pretraga-kataloga/moje-gradivo.component';
import { PretragaKatalogaComponent } from './components/pretraga-kataloga/pretraga-kataloga.component';
import { RegistarArhivaComponent } from './components/registar-arhiva/registar-arhiva.component';
import { HomePageComponent } from './admin/components/home-page/home-page.component';
import { PregledGradivaPoRokuCuvanjaComponent } from './features/izlucivanje/pregled-gradiva-po-roku-cuvanja/pregled-gradiva-po-roku-cuvanja.component';
import { UpravnaStvarListComponent } from './components/upravna_stvar/upravna_stvar_list/upravna_stvar_list.component';
import { MjestoPrikazComponent } from './components/mjesto-prikaz/mjesto-prikaz.component';
import { UserProfileComponent } from './components/user-profile/user-profile';

const ROUTE_VIEW = 'view/';
const ROUTE_HIERARCHY_VIEW = 'view/hierarchy/';
const ROUTE_VIEW_BY_NAME = ROUTE_VIEW + ':viewName';
const ROUTE_HIERARCHY_VIEW_BY_NAME = ROUTE_HIERARCHY_VIEW + ':viewName';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HomePageComponent
      },
      {
        path: 'user-profile',
        component: UserProfileComponent
      }
    ]
    //    resolve: { router: RoleRouteResolver }, FIXME ne radi za child module i ne koristimo
  },
  {
    path: 'administracija',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'view/mjesto',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: MjestoPrikazComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'moja-institucija',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: MojaInstitucijaComponent
      }
    ]
  },
  {
    path: ROUTE_HIERARCHY_VIEW_BY_NAME,
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: MainHierarchylistviewComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/registar_arhiva_i_posjednika',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: RegistarArhivaComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/agent',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: AgentPrikazComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/jedinica_gradiva',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: PretragaKatalogaComponent,
        children: [
          {
            path: 'hierarhija',
            component: HierarhijaComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'hierarhija-klasifikacija',
            component: HierarhijaKlasifikacijaComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'hierarhija-pozicija',
            component: HierarhijaPozicijaComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'hierarhija-posebni-popis',
            component: HierarhijaPosebniPopisComponent,
            canActivate: [AuthGuard]
          }
        ]
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/moje_gradivo',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: MojeGradivoComponent,
        data: {
          isMojeGradivo: true
        },
        children: [
          {
            path: 'hierarhija',
            component: HierarhijaComponent,
            canActivate: [AuthGuard],
            data: {
              isMojeGradivo: true
            }
          },
          {
            path: 'hierarhija-klasifikacija',
            component: HierarhijaKlasifikacijaComponent,
            canActivate: [AuthGuard],
            data: {
              isMojeGradivo: true
            }
          },
          {
            path: 'hierarhija-posebni-popis',
            component: HierarhijaPosebniPopisComponent,
            canActivate: [AuthGuard],
            data: {
              isMojeGradivo: true
            }
          }
        ]
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/jedinice_gradiva_po_roku_cuvanja',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: PregledGradivaPoRokuCuvanjaComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'view/seup.klasa',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: KlasaListComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_VIEW_BY_NAME,
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: MAIN_VIEW_COMPONENT
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'dokumentacija',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: DokumentacijaHierarhijaComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'upravne_stvari',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: UpravnaStvarListComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'spremiste2d',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: Spremiste2DComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./components/login.component/login.module').then(
        (m) => m.LoginModule
      )
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import(
        './components/change-password.component/change-password.module'
      ).then((m) => m.ChangePasswordModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
